import UpdateResourceForm from './UpdateResourceForm';

export default UpdateResourceForm;
